module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Irene Dische\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Irene Dische")]), _vm._v("'s work has appeared in numerous magazines, including "), _c('I', [_vm._v("The New Yorker")]), _vm._v(", and her books, published in twenty-two countries, have included international bestsellers. She divides her time between Berlin and Rhinebeck, New York.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/11zoEaN/tc-custom/9781429933391.jpg?1724432672625",
      "alt": "This image is the cover for the book Empress of Weehawken"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Empress of Weehawken\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("At the end of what is (she cannot help observing) an extraordinary life, Elisabeth Rother has decided to write her memoirs. She brushes aside her narrow escape with her Jewish husband from the Nazis, and the perilous voyage to the New World of New Jersey. The subject that really consumes her is the waywardness of her impossible daughter, Renate, and her granddaughter, Irene."), _c('br'), _c('br'), _vm._v("Renate performs autopsies on the bodies of politicians whom death has harvested in the nighttime arms of their mistresses. Worse, she sleeps on unironed sheets. Irene drops out of school to roam the world, refuses to correct her nose with plastic surgery, and shows alarming signs of enjoying sex. What is to be done with such women?"), _c('br'), _c('br'), _vm._v("A curiously touching love letter to the difficult but sustaining love of mothers and daughters, "), _c('i', [_vm._v("The Empress of Weehawken ")]), _vm._v("is a masterpiece of comedy with an unexpected lilt of redemption at its close.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0